import React from 'react'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { Property } from '../../../types/Property/Property'
import { useSelector } from '../../../store'
import { getNft, getNftYield } from '../../../store'
import { classNames } from '../../../lib/utils/classNames'
import routes from '../../../config/routes'
import Link from 'next/link'
import useCurrency from '../../../hooks/useCurrency'
import useLocale from '../../../hooks/useLocale'
import { useTranslation } from 'next-i18next'

interface PropertyTabElemProps {
  property: Property
  classname?: string
}

export default function PropertyTabElem({
  property,
  classname = '',
}: PropertyTabElemProps) {
  const { t } = useTranslation('dashboard')
  const nft = useSelector(
    getNft(property.nftCollectionId + '-' + property.nftNonce),
  )

  const nftPayout = useSelector(getNftYield(nft.identifier))
  const { currency } = useCurrency()
  const { locale } = useLocale()

  return (
    <div className={classNames(classname, 'overflow-hidden')}>
      <div className="grid grid-cols-6">
        <div className="col-span-3">
          <Link href={routes.property.replace('[propertyId]', property.id)}>
            <div className="text-xs font-bold text-neutralBlack">
              {property.translation.title}
            </div>
          </Link>
        </div>
        <div className="text-center text-xs text-neutralBlack">
          {nft.balance}
        </div>
        <div className="text-center text-xs font-bold text-neutralBlack">
          {formatCurrency(
            property.fractionCurrentPrice * nft.balance,
            2,
            2,
            currency,
            locale,
          )}
        </div>
        <div className="text-center text-xs text-neutralBlack">
          <span className="font-normal">~</span>
          {formatCurrency(
            nftPayout ? nftPayout.nextYield.monthlyYields : 0,
            2,
            2,
            currency,
            locale,
          )}
          &nbsp;/{t('statsCards.monthlyYieldsCard.month')}
        </div>
      </div>
    </div>
  )
}
